const template = `
	<div class="text-area" :class="classMap">
		<div v-if="error" class="error-msg">{{ error }}</div>
		<div v-if="prependIcon" class="prepend-icon" @click="focus">
			<i :class="'fa fa-fw fa-' + prependIcon"></i>
		</div>
		<textarea
			ref="tf"
			:value="value"
			:placeholder="placeholder"
			:name="name"
			:disabled="disabled"
			:readonly="readonly"
			@focus="onFocus"
			@blur="onBlur"
			@input="$emit('input', $event.target.value)"
			@change="$emit('change', $event)"
		></textarea>
		<i v-if="error" class="error-icon fa fa-exclamation-triangle"></i>
		<i v-if="loading" class="loading-icon fa fa-spinner spin-fast"></i>
	</div>
`;

export default {
	template,
	props: [
		'value',
		'type',
		'prepend-icon',
		'placeholder',
		'name',
		'disabled',
		'readonly',
		'error',
		'loading',
		'autofocus'
	],
	data() {
		return {
			focused: false
		}
	},
	computed: {
		inputType() {
			return this.type || 'text';
		},
		classMap() {
			return {
				'text-area-left-icon': this.prependIcon,
				'text-area-focused': this.focused,
				'text-area-disabled': this.disabled,
				'text-area-error': this.error,
				'text-area-loading': this.loading
			};
		}
	},
	methods: {
		onFocus() {
			this.focused = true;
		},
		onBlur() {
			this.focused = false;
		},
		focus() {
			this.$refs.tf.focus();
		}
	},
	mounted() {
		if (this.autofocus) {
			this.focus();
		}
	}
}